var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideocamFilled = function SvgVideocamFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M2.246 8.998a3.75 3.75 0 0 1 3.75-3.75h7.056a3.75 3.75 0 0 1 3.74 3.472l2.293-1.413a1.75 1.75 0 0 1 2.669 1.49v6.406a1.75 1.75 0 0 1-2.67 1.49l-2.292-1.413a3.75 3.75 0 0 1-3.74 3.473H5.996a3.75 3.75 0 0 1-3.75-3.75V8.997Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideocamFilled);
export default ForwardRef;